export function transToFormData(data: Object) {
  const formData = new FormData();
  for (const key in data) {
    if (Object.hasOwnProperty.call(data, key)) {
      formData.append(key, data[key]);
    }
  }
  return formData;
}

export function transToBlob(data: Object) {
  return new Blob([JSON.stringify(data)], { type: 'application/json; charset=utf-8' });
}
